export default () => <span aria-hidden="true" style={{color: '#E91B0C'}}>{' *'}</span>
